// extracted by mini-css-extract-plugin
export default {"bookmarks":"bookmarks-hMDW"};